export default __webpack_public_path__ + "static/e8722fe2881799fd88be18c59c6ab5d6.png";